import { useState, useEffect, useRef } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const MAX_WORDS = 5;

/**
 * Horizontal ticker showing the most recent few words of partial transcript.
 * Words slide in from the right and scroll left.
 */
export default function WordTicker({ text }) {
  const [displayWords, setDisplayWords] = useState([]);
  const containerRef = useRef(null);
  const keyCounter = useRef(0);

  useEffect(() => {
    if (!text) {
      setDisplayWords([]);
      return;
    }

    const words = text.trim().split(/\s+/).filter(Boolean);
    const recent = words.slice(-MAX_WORDS);

    setDisplayWords(
      recent.map((word, i) => ({
        word,
        key: ++keyCounter.current,
        isNew: i === recent.length - 1,
      }))
    );
  }, [text]);

  return (
    <Box
      ref={containerRef}
      sx={{
        overflow: 'hidden',
        height: 32,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
      }}
    >
      <Box sx={{
        display: 'flex',
        gap: '0.4em',
        transition: 'transform 0.3s ease',
      }}>
        {displayWords.map(({ word, key, isNew }) => (
          <Typography
            key={key}
            component="span"
            sx={{
              fontSize: '14px',
              color: 'text.secondary',
              opacity: isNew ? 1 : 0.5,
              fontWeight: isNew ? 500 : 400,
              transition: 'opacity 0.4s ease',
              whiteSpace: 'nowrap',
              animation: isNew ? 'tickerSlideIn 0.3s ease' : 'none',
              '@keyframes tickerSlideIn': {
                from: { opacity: 0, transform: 'translateX(12px)' },
                to: { opacity: 1, transform: 'translateX(0)' },
              },
            }}
          >
            {word}
          </Typography>
        ))}
      </Box>
    </Box>
  );
}
